import { SvgIconProps } from '@spazious/dollhouse-icons';
import { decodeFCompositionId, encodeFCompositionId } from '@spazious/dollhouse-shallow-graph';

import { fcompositionSchemaIconMapping } from '../constants/index.js';

/**
 * Helper function to get the icon for a given FComposition schema.
 */
export const parseFCompositionIcon = (nid: number): React.FC<SvgIconProps> => {
  const { type, subtype } = decodeFCompositionId(nid);
  return fcompositionSchemaIconMapping[encodeFCompositionId(type, subtype)] ?? (() => null);
};
